import { type ReactNode, useState } from 'react';

import Dialog, { DialogActions, DialogContent, DialogTitle } from 'components/dialog';

type RentOrBuyModalProps = {
  heading: string;
  subheading: string;
  rentList: string[];
  buyList: string[];
  footerRentButton?: ReactNode;
  footerBuyButton?: ReactNode;
};

const RentOrBuyModal = ({ heading, subheading, rentList, buyList, footerRentButton, footerBuyButton }: RentOrBuyModalProps) => {
  const [open, setOpen] = useState(false);
  const maxRows = Math.max(rentList?.length ?? 0, buyList?.length ?? 0);

  return (
    <>
      <p className="text-h5 px-8 text-center uppercase !text-gray-darker xs:text-h4">
        Compare{' '}
        <span className="cursor-pointer font-bold underline" onClick={() => setOpen(true)}>
          renting &amp; buying
        </span>{' '}
        with Generation Tux.
      </p>

      <Dialog className="md:h-4/6 xl:h-5/7 xl:w-5/7" open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          <DialogTitle className="text-h2-display">{heading}</DialogTitle>
          <div className="mt-8 p-24 sm:mt-24 sm:pt-0">
            <p>{subheading}</p>
            <div className="text-sm mt-24">
              <div className="flex space-x-8 pb-8">
                <h5 className="text-h5 w-1/2 flex-grow">Rent</h5>
                <h5 className="text-h5 w-1/2 flex-grow">Buy</h5>
              </div>
              <hr className="border-t-1 border-gray-darker" />
              {Array.from({ length: maxRows }).map((_, i) => (
                <div key={i} className={`flex space-x-8 ${i % 2 === 0 ? 'bg-gray-lighter' : ''} py-16`}>
                  <div className="w-1/2 flex-grow px-8">{rentList?.[i] ?? ''}</div>
                  <div className="w-1/2 flex-grow px-8">{buyList?.[i] ?? ''}</div>
                </div>
              ))}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          {footerRentButton}
          {footerBuyButton}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RentOrBuyModal;
